

export default {
    props: {
        city: Object,
        metrics: Array
    },
    data: function() {
        return {
            items: [
                {
                    'name' : 'Cambriolages',
                    'code' : 'BURGLARY_RATE_BY_POP'
                },
                {
                    'name' : 'Vols automobiles',
                    'code' : 'VOL_AUTOMOBILE_BY_POP'
                },
                {
                    'name' : 'Vols de particulier',
                    'code' : 'VOL_SIMPLE_PARTICULIER_BY_POP'
                },
                {
                    'name' : 'Violences physiques',
                    'code' : 'VIOLENCES_PHYSIQUES_BY_POP'
                },
                {
                    'name' : 'Violences sexuelles',
                    'code' : 'VIOLENCES_SEXUELLES_BY_POP'
                }
            ]
        };
    },
}
